<template>
  <div class="drive-manage">
    <div class="introduce">
      <div class="description">
        <div class="title">
          长安链·ChainMaker
        </div>
        <div class="detail">
          长安链作为区块链开源底层软件平台，包涵区块链核心框架、丰富的组件库和工具集，致力于为用户高效、精准地解决差异化区块链实现需求，构建高性能、高可信、高安全的新型数字基础设施，同时也是国内首个自主可控区块链软硬件技术体系。
        </div>
        <div class="vector-dec"></div>
      </div>
      <div class="fill"></div>
      <el-link
        class="img-link"
        :underline="false"
        href="https://git.chainmaker.org.cn/chainmaker/chainmaker-go.git"
        target="_blank"
      >
        <img :src="sourceBtnBg" alt="" />
        <div class="text">源码下载</div>
      </el-link>
      <el-link
        :underline="false"
        class="img-link"
        href="https://docs.chainmaker.org.cn/v2.1.0/html/index.html"
        target="_blank"
      >
        <img :src="docBtnBg" alt="" />
        <div class="text">开源文档</div>
      </el-link>
    </div>
    <div class="card-wrap">
      <div v-for="ele in downList" :key="ele.name" :class="['card-item', ele.bg]">
        <div class="name">{{ ele.name }}</div>
        <div class="description">{{ ele.description }}</div>
        <div class="btn-area">
          <el-link
            class="btn-link look-btn"
            :underline="false"
            :href="ele.fileLink"
            target="_blank"
          >
            <span :class="['iconfont', 'icon-check', 'link-icon']"></span>
            <span>查看文档</span>
          </el-link>
          <el-link class="btn-link down-btn border-link" :underline="false" :href="ele.sdkLink" target="_blank">
            <span :class="['iconfont', 'icon-download', 'link-icon']"></span>
            <span>SDK下载</span>
          </el-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import docBtnBg from '@/assets/images/drive/doc-btn-bg.png'
import sourceBtnBg from '@/assets/images/drive/source-btn-bg.png'
export default {
  name: 'Index',
  data() {
    return {
      sourceBtnBg,
      docBtnBg,
      downList: [
        {
          name: 'GO',
          description: '版本为1.15或以上',
          bg: 'go',
          sdkLink: 'https://git.chainmaker.org.cn/chainmaker/chainmaker-sdk-go.git',
          fileLink: 'https://docs.chainmaker.org.cn/v2.1.0/html/dev/SDK.html'
        },
        {
          name: 'JAVA',
          description: 'jdk 1.8.0_202或以下',
          bg: 'java',
          sdkLink: 'https://git.chainmaker.org.cn/chainmaker/chainmaker-sdk-java.git',
          fileLink: 'https://docs.chainmaker.org.cn/v2.1.0/html/dev/SDK.html'
        },
        {
          name: 'Nodejs',
          description: 'nodejs.14.0.0+',
          bg: 'node',
          sdkLink: 'https://git.chainmaker.org.cn/chainmaker/chainmaker-sdk-nodejs.git',
          fileLink: 'https://docs.chainmaker.org.cn/v2.1.0/html/dev/SDK.html'
        }
      ]
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';
@include theme(
  'drive-manage',
  (
    --drive-manage-introduce-description-title-color: #fff,
    --drive-manage-introduce-description-detail-color: #fff,
    --drive-manage-introduce-img-link-color: #fff,
    --drive-manage-card-wrap-border-color: #7abeec,
    --drive-manage-card-wrap-background-color: #232d51,
    --drive-manage-card-wrap-card-item-box-shadow-color: rgba(1, 31, 48, 0.73),
    --drive-manage-card-wrap-card-item-name-color: #fff,
    --drive-manage-card-wrap-card-item-description-color: #fff,
    --drive-manage-card-wrap-card-item-btn-area-color: #fff,
    --drive-manage-card-wrap-card-item-btn-link-color: #ffffff,
    --drive-manage-card-wrap-card-item-btn-link-hover-border-color: #ffffff,
    --drive-manage-card-wrap-card-item-btn-link-hover-background-color: rgba(0, 0, 0, 0.1),
    --drive-manage-bg-image: url('~@/assets/images/drive/des-bg.png')
  ),
  (
    --drive-manage-introduce-description-title-color: #fff,
    --drive-manage-introduce-description-detail-color: #fff,
    --drive-manage-introduce-img-link-color: #fff,
    --drive-manage-card-wrap-border-color: #ebebeb,
    --drive-manage-card-wrap-background-color: #f6f7f9,
    --drive-manage-card-wrap-card-item-box-shadow-color: transparent,
    --drive-manage-card-wrap-card-item-name-color: #fff,
    --drive-manage-card-wrap-card-item-description-color: #fff,
    --drive-manage-card-wrap-card-item-btn-area-color: #fff,
    --drive-manage-card-wrap-card-item-btn-link-color: #ffffff,
    --drive-manage-card-wrap-card-item-btn-link-hover-border-color: #ffffff,
    --drive-manage-card-wrap-card-item-btn-link-hover-background-color: rgba(0, 0, 0, 0.1),
    --drive-manage-bg-image: url('~@/assets/images/drive/des-bg-light.png')
  )
);
.drive-manage {
  @include adaptation(
    (
      --drive-manage-introduce-height: 248px,
      --drive-manage-introduce-padding-right: 131px,
      --drive-manage-introduce-description-padding: 46px 68px,
      --drive-manage-introduce-description-title-font-size: 26px,
      --drive-manage-introduce-description-title-padding: 6px 0,
      --drive-manage-introduce-description-detail-font-size: 12px,
      --drive-manage-introduce-description-detail-width: 476px,
      --drive-manage-introduce-description-detail-padding: 6px 0,
      --drive-manage-introduce-description-vector-width: 230px,
      --drive-manage-introduce-description-vector-height: 24px,
      --drive-manage-introduce-description-vector-margin-top: 10px,
      --drive-manage-introduce-img-link-margin-right: 83px,
      --drive-manage-introduce-img-link-font-size: 12px,
      --drive-manage-introduce-img-link-img-size: 60px,
      --drive-manage-introduce-img-link-img-margin-bottom: 6px,
      --drive-manage-introduce-img-link-text-line-height: 17px,
      --drive-manage-card-wrap-margin-top: 16px,
      --drive-manage-card-wrap-border-width: 1px,
      --drive-manage-card-wrap-padding: 32px 23px,
      --drive-manage-card-wrap-card-item-height: 171px,
      --drive-manage-card-wrap-card-item-box-shadow-size: 2px 2px 24px 0px,
      --drive-manage-card-wrap-card-item-padding: 28px 16px 18px 38px,
      --drive-manage-card-wrap-card-item-name-font-size: 22px,
      --drive-manage-card-wrap-card-item-description-font-size: 12px,
      --drive-manage-card-wrap-card-item-btn-area-margin-top: 46px,
      --drive-manage-card-wrap-card-item-btn-area-font-size: 12px,
      --drive-manage-card-wrap-card-item-btn-link-margin-left: 16px,
      --drive-manage-card-wrap-card-item-btn-link-width: 88px,
      --drive-manage-card-wrap-card-item-btn-link-height: 28px,
      --drive-manage-card-wrap-card-item-btn-link-border-width: 1px,
      --drive-manage-card-wrap-card-item-btn-link-border-radius: 2px,
      --drive-manage-card-wrap-card-item-btn-link-padding: 6px 8px,
      --drive-manage-card-wrap-card-item-btn-link-line-height: 16px
    )
  );
  --drive-manage-card-wrap-min-height: calc(
    var(--base-main-router-body-avaliable-height) - var(--drive-manage-introduce-height) -
      var(--drive-manage-card-wrap-margin-top)
  );
  .introduce {
    background-image: var(--drive-manage-bg-image);
    background-size: 100% 100%;
    height: var(--drive-manage-introduce-height);
    padding-right: var(--drive-manage-introduce-padding-right);
    display: flex;
    align-items: center;

    .description {
      display: flex;
      flex-direction: column;
      padding: var(--drive-manage-introduce-description-padding);
      align-self: flex-start;

      .title {
        color: var(--drive-manage-introduce-description-title-color);
        font-size: var(--drive-manage-introduce-description-title-font-size);
        font-weight: 700;
        padding: var(--drive-manage-introduce-description-title-padding);
      }

      .detail {
        color: var(--drive-manage-introduce-description-detail-color);
        font-size: var(--drive-manage-introduce-description-detail-font-size);
        width: var(--drive-manage-introduce-description-detail-width);
        padding: var(--drive-manage-introduce-description-detail-padding);
      }

      .vector-dec {
        width: var(--drive-manage-introduce-description-vector-width);
        height: var(--drive-manage-introduce-description-vector-height);
        background-image: url('~@/assets/images/drive/vector.png');
        background-size: 100% 100%;
        margin-top: var(--drive-manage-introduce-description-vector-margin-top);
      }
    }

    .fill {
      flex-grow: 1;
    }

    .img-link {
      display: flex;
      flex-direction: column;
      margin-right: var(--drive-manage-introduce-img-link-margin-right);
      color: var(--drive-manage-introduce-img-link-color);
      font-size: var(--drive-manage-introduce-img-link-font-size);

      img {
        width: var(--drive-manage-introduce-img-link-img-size);
        height: var(--drive-manage-introduce-img-link-img-size);
        transition-duration: 300ms;
        margin-bottom: var(--drive-manage-introduce-img-link-img-margin-bottom);
        display: block;
      }

      &:hover img {
        transform: scale(1.2, 1.2);
        transform-origin: 50% 100%;
      }

      .text {
        display: block;
        text-align: center;
        line-height: var(--drive-manage-introduce-img-link-text-line-height);
      }
    }
  }

  .card-wrap {
    background-image: url('~@/assets/images/drive/download-bg.png');
    background-size: 100% 100%;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    min-height: var(--drive-manage-card-wrap-min-height);
    margin-top: var(--drive-manage-card-wrap-margin-top);
    border: var(--drive-manage-card-wrap-border-width) solid
      var(--drive-manage-card-wrap-border-color);
    background-color: var(--drive-manage-card-wrap-background-color);
    padding: var(--drive-manage-card-wrap-padding);

    .card-item {
      width: 32.3%;
      height: var(--drive-manage-card-wrap-card-item-height);
      box-shadow: var(--drive-manage-card-wrap-card-item-box-shadow-size)
        var(--drive-manage-card-wrap-card-item-box-shadow-color);
      padding: var(--drive-manage-card-wrap-card-item-padding);

      .name {
        color: var(--drive-manage-card-wrap-card-item-name-color);
        font-size: var(--drive-manage-card-wrap-card-item-name-font-size);
        font-weight: 700;
      }

      .description {
        color: var(--drive-manage-card-wrap-card-item-description-color);
        font-size: var(--drive-manage-card-wrap-card-item-description-font-size);
      }

      .btn-area {
        margin-top: var(--drive-manage-card-wrap-card-item-btn-area-margin-top);
        display: flex;
        align-items: center;
        justify-content: flex-end;
        color: var(--drive-manage-card-wrap-card-item-btn-area-color);
        font-size: var(--drive-manage-card-wrap-card-item-btn-area-font-size);

        .btn-link {
          color: var(--drive-manage-card-wrap-card-item-btn-link-color);
          display: inline-block;
          margin-left: var(--drive-manage-card-wrap-card-item-btn-link-margin-left);
          width: var(--drive-manage-card-wrap-card-item-btn-link-width);
          height: var(--drive-manage-card-wrap-card-item-btn-link-height);
          border: var(--drive-manage-card-wrap-card-item-btn-link-border-width) solid transparent;
          border-radius: var(--drive-manage-card-wrap-card-item-btn-link-border-radius);
          text-align: center;
          padding: var(--drive-manage-card-wrap-card-item-btn-link-padding);
          line-height: var(--drive-manage-card-wrap-card-item-btn-link-line-height);
          transition-property: all;
          transition-duration: 300ms;

          &.border-link {
            border-color: var(--drive-manage-card-wrap-card-item-btn-link-hover-border-color);
          }

          .link-icon {
            margin-right: var(--base-size-4);
          }

          &:hover {
            border-color: var(--drive-manage-card-wrap-card-item-btn-link-hover-border-color);
            background-color: var(
              --drive-manage-card-wrap-card-item-btn-link-hover-background-color
            );
          }
        }
      }
    }

    .go {
      background: url('~@/assets/images/drive/go-bg.png');
      background-size: 100% 100%;
    }

    .java {
      background: url('~@/assets/images/drive/java-bg.png');
      background-size: 100% 100%;
    }

    .node {
      background: url('~@/assets/images/drive/node-bg.png');
      background-size: 100% 100%;
    }
  }
}
</style>
